export const VOUCHER_USE_TYPE = {
  BOOKESE: 'BOOKESE',
  PARTNER: 'PARTNER',
  BOOKESE_PUBLIC: 'BOOKESE_PUBLIC',
};

export const VOUCHER_USE_TYPE_OPTIONS = [
  { value: VOUCHER_USE_TYPE.BOOKESE, label: 'BOOKESE' },
  { value: VOUCHER_USE_TYPE.PARTNER, label: 'PARTNER' },
  { value: VOUCHER_USE_TYPE.BOOKESE_PUBLIC, label: 'BOOKESE_PUBLIC' },
];

export const DISCOUNT_TYPE = {
  PERCENT: 'PERCENT',
  AMOUNT: 'AMOUNT',
};

export const DISCOUNT_TYPE_OPTIONS = [
  { value: DISCOUNT_TYPE.PERCENT, label: 'PERCENT' },
  { value: DISCOUNT_TYPE.AMOUNT, label: 'AMOUNT' },
];

export const VOUCHER_APPLY_TYPE = {
  MIN_BOOKING_AMOUNT: 'MIN_BOOKING_AMOUNT',
  NEW_USER: 'NEW_USER',
  FOR_MEMBER: 'FOR_MEMBER',
  FOR_AGENT: 'FOR_AGENT',
  FOR_AMBASSADOR: 'FOR_AMBASSADOR',
  FOR_TOURIST: 'FOR_TOURIST',
};

export const VOUCHER_APPLY_TYPE_LABELS = {
  [VOUCHER_APPLY_TYPE.MIN_BOOKING_AMOUNT]: 'Đơn hàng tối thiểu',
  [VOUCHER_APPLY_TYPE.NEW_USER]: 'Người dùng mới',
  [VOUCHER_APPLY_TYPE.FOR_MEMBER]: 'Dành cho thành viên',
  [VOUCHER_APPLY_TYPE.FOR_AGENT]: 'Dành cho đại lý',
  [VOUCHER_APPLY_TYPE.FOR_AMBASSADOR]: 'Dành cho đại sứ',
  [VOUCHER_APPLY_TYPE.FOR_TOURIST]: 'Dành cho du khách',
};

export const VOUCHER_APPLY_TYPE_OPTIONS = Object.values(VOUCHER_APPLY_TYPE).map(
  (value) => ({
    value,
    label: VOUCHER_APPLY_TYPE_LABELS[value],
  }),
);

export const isBookeseDiscountUseType = (useType) => (
  useType === VOUCHER_USE_TYPE.BOOKESE
  || useType === VOUCHER_USE_TYPE.BOOKESE_PUBLIC
);

export const isBookesePublicUseType = (useType) => (
  useType === VOUCHER_USE_TYPE.BOOKESE_PUBLIC
);
